import { Grid } from "@material-ui/core";
import {
  createAutocompleteAddressField,
  createCurrencyField,
  createDateField,
  createNumberFormatField,
  createPercentageField,
  createTextField,
  EditableDialog,
} from "@roc/ui";
import { observer } from "mobx-react";
import { useEffect } from "react";

export const EditRealEstateTransactionDialog = observer(({ editRealEstateTransactionStore }) => {
  const store = editRealEstateTransactionStore;

  useEffect(() => {

  }, [store.dialogOpen])

  const handleAddressChange = event => {
    const { value } = event?.target || {};
    store.onFieldChange('propertyAddress', value);
  };

  const dialogContent = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {createAutocompleteAddressField({
              store,
              testId: 'propertyAddress',
              fieldName: 'propertyAddress',
              label: 'Property Address',
              onChange: handleAddressChange,
            })}
      </Grid>
      <Grid item xs={6}>
        {createCurrencyField({
          store,
          testId: 'purchasePrice',
          fieldName: 'purchasePrice',
          label: 'Purchase Price',
        })}
      </Grid>

      <Grid item xs={6}>
        {createCurrencyField({
          store,
          testId: 'mortgageAmount',
          fieldName: 'mortgageAmount',
          label: 'Mortgage Amount',
        })}
      </Grid>

      <Grid item xs={6}>
        {createPercentageField({
          store,
          testId: 'interestRate',
          fieldName: 'interestRate',
          label: 'Interest Rate (%)',
        })}
      </Grid>

      <Grid item xs={6}>
        {createPercentageField({
          store,
          testId: 'ltc',
          fieldName: 'ltc',
          label: 'LTC (%)',
        })}
      </Grid>

      <Grid item xs={6}>
        {createPercentageField({
          store,
          testId: 'arltv',
          fieldName: 'arltv',
          label: 'ARLTV (%)',
        })}
      </Grid>

      <Grid item xs={6}>
        {createNumberFormatField({
          store,
          testId: 'ficoScore',
          fieldName: 'ficoScore',
          label: 'FICO Score',
        })}
      </Grid>

      <Grid item xs={6}>
        {createDateField({
          store,
          testId: 'purchaseDate',
          fieldName: 'purchaseDate',
          label: 'Purchase Date',
        })}
      </Grid>

      <Grid item xs={6}>
        {createDateField({
          store,
          testId: 'saleDate',
          fieldName: 'saleDate',
          label: 'Sale Date',
        })}
      </Grid>
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'transactionType',
          fieldName: 'transactionType',
          label: 'Transaction Type',
        })}
      </Grid>
    </Grid>
  );

  return (
    <EditableDialog
      open={store.dialogOpen}
      dialogState={store.dialogState}
      handleClose={() => store.closeDialog()}
      title={'Real Estate Transaction'}
      dialogContent={dialogContent}
      handleEdit={() => store.saveRealEstateTransaction()}
      handleAdd={() => store.saveRealEstateTransaction()}
    />
  );
});
